import * as React from "react";
import { IconButton, Snackbar, Stack } from "@mui/material";
import { useSnackbar } from "@/hooks/useSnackbar";
import CloseIcon from "@mui/icons-material/Close.js";
import { SnackbarMessageContainer } from "./styles";

export function CustomizedSnackbars() {
  const { handleCloseSnackbar, openSnackbar, description, message, error } = useSnackbar();

  return (
    <Stack
      spacing={2}
      sx={{ width: "100%", position: "relative", zIndex: 9999999999 }}
    >
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <SnackbarMessageContainer error={error}>
          <div className="message_wrapper">
            <p>{message}</p>
            <IconButton
              aria-label="close"
              color="inherit"
              sx={{ p: 0.5 }}
              onClick={handleCloseSnackbar}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <span>{description}</span>
        </SnackbarMessageContainer>
      </Snackbar>
    </Stack>
  );
}
